<template>
  <el-page-header class="page-header" title="返回微信列表" @back="router.push('/wechat')">
    <template #content>账号详情</template>
  </el-page-header>
  <el-row :gutter="20" class="row avatar-row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">头像</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">
      <el-avatar shape="square" :size="100" :src="wechatUser.headUrl" />
    </el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">昵称</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">{{ wechatUser.nickName }}</el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">用户名</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">{{ wechatUser.username }}</el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">微信号</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">{{ wechatUser.wAccount }}</el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">微信Id</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">{{ wechatUser.wcId }}</el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">手机号</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">{{ wechatUser.mobilePhone }}</el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">测试工具</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">
      <div class="tools-toolbar">
        <el-button size="small" type="warning" @click="openForwardDialog()">按 msgId 转发</el-button>
        <el-button size="small" @click="openJobStatusDialog()">查询任务状态</el-button>
        <span class="tools-hint">点击列表 Chat 按钮发送文本/语音/视频/链接/小程序/AppXml</span>
      </div>
    </el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">好友列表</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">
      <div class="list-toolbar">
        <el-button size="small" @click="refreshFriends">刷新群聊和好友</el-button>
        <el-input v-model="friendQuery" class="list-search" placeholder="搜索昵称或微信号" clearable size="small" />
        <el-pagination
          v-model:current-page="friendPageNum"
          v-model:page-size="friendPageSize"
          :total="filteredFriends.length"
          :page-sizes="[20, 50, 100]"
          :layout="paginationLayout"
          :small="isMobile"
          :pager-count="isMobile ? 5 : 7"
        />
        <span class="list-count">{{ filteredFriends.length }} / {{ friendsData.length }}</span>
      </div>
      <div class="inner-table" :style="friendTableStyle">
        <el-auto-resizer>
          <template #default="{ height, width }">
            <el-table-v2 :columns="friendColumns" :data="paginatedFriends" :width="width" :height="height" fixed />
          </template>
        </el-auto-resizer>
      </div>
    </el-col>
  </el-row>
  <el-row :gutter="20" class="row">
    <el-col :xs="24" :sm="4" :md="2" :lg="2" :xl="1" class="caption">群聊列表</el-col>
    <el-col :xs="24" :sm="20" :md="22" :lg="22" :xl="23">
      <div class="list-toolbar">
        <el-input v-model="chatroomQuery" class="list-search" placeholder="搜索群名称" clearable size="small" />
        <el-pagination
          v-model:current-page="chatroomPageNum"
          v-model:page-size="chatroomPageSize"
          :total="filteredChatrooms.length"
          :page-sizes="[20, 50, 100]"
          :layout="paginationLayout"
          :small="isMobile"
          :pager-count="isMobile ? 5 : 7"
        />
        <span class="list-count">{{ filteredChatrooms.length }} / {{ chatroomsData.length }}</span>
      </div>
      <div class="inner-table" :style="chatroomTableStyle">
        <el-auto-resizer>
          <template #default="{ height, width }">
            <el-table-v2 :columns="chatroomColumns" :data="paginatedChatrooms" :width="width" :height="height" fixed />
          </template>
        </el-auto-resizer>
      </div>
    </el-col>
  </el-row>

  <!-- Multi-type send dialog. The form fields swap based on `sendType`. -->
  <el-dialog
    v-model="sendDialogVisible"
    :title="sendDialogTitle"
    width="640px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :align-center="true"
  >
    <el-tabs v-model="sendType">
      <el-tab-pane label="文本" name="text">
        <el-form label-position="top">
          <el-form-item label="消息内容">
            <el-input v-model="form.text.message" :rows="5" type="textarea" placeholder="文本消息" />
          </el-form-item>
          <el-form-item label="@ (群消息时填要 @ 的 wxid)">
            <el-input v-model="form.text.at" placeholder="可留空" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="语音" name="voice">
        <el-form label-position="top">
          <el-form-item label="语音文件 URL (silk/amr，已上传到 CDN)">
            <el-input v-model="form.voice.contentUrl" placeholder="https://cdn.example.com/.../xxxx.silk" />
          </el-form-item>
          <el-form-item label="时长（毫秒）">
            <el-input-number v-model="form.voice.lengthMs" :min="1" :step="100" />
          </el-form-item>
          <div class="form-hint">wkteam 文档标记 /sendVoice 为「即将开放」，请先在上游平台验证可用性。</div>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="视频" name="video">
        <el-form label-position="top">
          <el-form-item label="视频 URL/path">
            <el-input v-model="form.video.videoPath" placeholder="https://... 或 wkteam 内部 path" />
          </el-form-item>
          <el-form-item label="缩略图 URL/path（建议 ≤50KB）">
            <el-input v-model="form.video.thumbPath" placeholder="https://... 或 wkteam 内部 path" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="链接卡片" name="link">
        <el-form label-position="top">
          <el-form-item label="标题">
            <el-input v-model="form.link.title" />
          </el-form-item>
          <el-form-item label="跳转 URL">
            <el-input v-model="form.link.url" placeholder="https://..." />
          </el-form-item>
          <el-form-item label="描述（可选）">
            <el-input v-model="form.link.description" />
          </el-form-item>
          <el-form-item label="缩略图 URL（可选）">
            <el-input v-model="form.link.thumbUrl" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="小程序" name="applet">
        <el-form label-position="top">
          <el-form-item label="displayName">
            <el-input v-model="form.applet.displayName" />
          </el-form-item>
          <el-form-item label="iconUrl">
            <el-input v-model="form.applet.iconUrl" />
          </el-form-item>
          <el-form-item label="appId">
            <el-input v-model="form.applet.appId" />
          </el-form-item>
          <el-form-item label="pagePath">
            <el-input v-model="form.applet.pagePath" />
          </el-form-item>
          <el-form-item label="thumbUrl">
            <el-input v-model="form.applet.thumbUrl" />
          </el-form-item>
          <el-form-item label="title">
            <el-input v-model="form.applet.title" />
          </el-form-item>
          <el-form-item label="userName (gh_...)">
            <el-input v-model="form.applet.userName" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="AppXml" name="app">
        <el-form label-position="top">
          <el-form-item label="原始 <appmsg> XML">
            <el-input v-model="form.app.appXml" :rows="8" type="textarea" placeholder="<appmsg>...</appmsg>" />
          </el-form-item>
          <div class="form-hint">/sendApp 和 /sendApplet (转发)是两个独立端点，这里是 /sendApp（透传原始 XML）。</div>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div v-if="lastJobIds.length > 0" class="job-result">
      <div class="job-result-title">已入队 {{ lastJobIds.length }} 个任务：</div>
      <div v-for="id in lastJobIds" :key="id" class="job-result-row">
        <span class="job-result-id">{{ id }}</span>
        <el-button size="small" @click="queryJob(id)">查询</el-button>
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="sendDialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="sending" @click="dispatchSend()">发送</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- Forward by sourceMsgId / sourceNewMsgId -->
  <el-dialog
    v-model="forwardDialogVisible"
    title="按 msgId 转发已收到的消息"
    width="520px"
    :close-on-click-modal="false"
    :align-center="true"
  >
    <el-form label-position="top">
      <el-form-item label="接收者 wxid 或 *@chatroom（逗号分隔多个）">
        <el-input v-model="forwardForm.receiver" placeholder="wxid_user1,xxxxx@chatroom" />
      </el-form-item>
      <el-form-item label="sourceNewMsgId（优先）">
        <el-input v-model="forwardForm.sourceNewMsgId" placeholder="9876543210" />
      </el-form-item>
      <el-form-item label="sourceMsgId（备用）">
        <el-input v-model="forwardForm.sourceMsgId" placeholder="12345678" />
      </el-form-item>
      <div class="form-hint">源消息必须已经被 /recv 入库（或本网关自己发送过）。后端按存档的 messageType 自动派发到 forward_*。</div>
    </el-form>
    <div v-if="lastForwardResult" class="forward-result">
      <div>sourceMessageType: <code>{{ lastForwardResult.sourceMessageType }}</code></div>
      <div v-if="lastJobIds.length > 0">已入队任务：</div>
      <div v-for="id in lastJobIds" :key="id" class="job-result-row">
        <span class="job-result-id">{{ id }}</span>
        <el-button size="small" @click="queryJob(id)">查询</el-button>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="forwardDialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="sending" @click="dispatchForward()">转发</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- Job status lookup -->
  <el-dialog
    v-model="jobDialogVisible"
    title="查询任务状态"
    width="640px"
    :close-on-click-modal="false"
    :align-center="true"
  >
    <el-form label-position="top">
      <el-form-item label="jobId">
        <el-input v-model="jobIdInput" placeholder="paste jobId here">
          <template #append>
            <el-button @click="queryJob(jobIdInput)">查询</el-button>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <pre v-if="jobRecord" class="job-record">{{ jobRecordPretty }}</pre>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="jobDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog
    v-model="memberDialogVisible"
    :title="chatroomTitle"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :align-center="true"
  >
    <div class="member-table">
      <el-auto-resizer>
        <template #default="{ height, width }">
          <el-table-v2 :columns="memberColumns" :data="membersData" :width="width" :height="height" fixed />
        </template>
      </el-auto-resizer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="memberDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup lang="tsx">
import { computed, reactive, ref, watch } from "vue";
import {
  getWechatUser,
  wechatRefreshFriendsInfo,
  wechatSendMessage,
  wechatGetChatroomMembers,
  wechatSendVoice,
  wechatSendVideo,
  wechatSendLink,
  wechatSendApplet,
  wechatSendApp,
  wechatForwardBySource,
  wechatGetJob,
} from "../api/http";
import type { SendJobRecord, SendJobsResult } from "../api/http";
import { ElButton, ElAvatar, ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import type { WechatAccount, WechatChatroomMember, WechatContact } from "../api/models";
import { useBreakpoint } from "../composables/useBreakpoint";

const { isMobile } = useBreakpoint();

const friendChatRenderer = ({ rowData: row }: { rowData: any }) => (
  <>
    <ElButton size="small" type="success" icon="ChatDotRound" onClick={() => openSendDialog(row.nickName, row.v1)}></ElButton>
  </>
);
const friendAvatarRenderer = ({ cellData: url }: { cellData: string }) => (
  <ElAvatar shape="square" size={32} src={url}></ElAvatar>
);

const desktopFriendColumns = [
  { key: "order", dataKey: "order", title: "#", width: 60, align: "center" },
  { key: "smallHead", dataKey: "smallHead", title: "Avatar", width: 80, align: "center", cellRenderer: ({ cellData: url }: { cellData: string }) => (<ElAvatar shape="square" src={url}></ElAvatar>) },
  { key: "userName", dataKey: "userName", title: "Username", width: 220 },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 220, flexGrow: 1 },
  { key: "chat", dataKey: "v1", title: "Send", width: 80, align: "center", fixed: "right" as const, cellRenderer: friendChatRenderer },
];

const mobileFriendColumns = [
  { key: "smallHead", dataKey: "smallHead", title: "", width: 50, align: "center", cellRenderer: friendAvatarRenderer },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 100, flexGrow: 1 },
  { key: "chat", dataKey: "v1", title: "", width: 60, align: "center", fixed: "right" as const, cellRenderer: friendChatRenderer },
];

const friendColumns = computed(() => isMobile.value ? mobileFriendColumns : desktopFriendColumns);

const chatroomMembersRenderer = ({ rowData: row }: { rowData: any }) => (
  <>
    <ElButton size="small" type="success" icon="More" onClick={() => { chatroomTitle.value = row.nickName; showMembers(row.v1); }}></ElButton>
  </>
);

const desktopChatroomColumns = [
  { key: "order", dataKey: "order", title: "#", width: 60, align: "center" },
  { key: "smallHead", dataKey: "smallHead", title: "Avatar", width: 80, align: "center", cellRenderer: ({ cellData: url }: { cellData: string }) => (<ElAvatar shape="square" src={url}></ElAvatar>) },
  { key: "userName", dataKey: "userName", title: "Username", width: 220 },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 220, flexGrow: 1 },
  { key: "members", dataKey: "v1", title: "Members", width: 80, align: "center", cellRenderer: chatroomMembersRenderer },
  { key: "chat", dataKey: "v1", title: "Send", width: 80, align: "center", fixed: "right" as const, cellRenderer: friendChatRenderer },
];

const mobileChatroomColumns = [
  { key: "smallHead", dataKey: "smallHead", title: "", width: 50, align: "center", cellRenderer: friendAvatarRenderer },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 100, flexGrow: 1 },
  { key: "members", dataKey: "v1", title: "", width: 50, align: "center", cellRenderer: chatroomMembersRenderer },
  { key: "chat", dataKey: "v1", title: "", width: 50, align: "center", fixed: "right" as const, cellRenderer: friendChatRenderer },
];

const chatroomColumns = computed(() => isMobile.value ? mobileChatroomColumns : desktopChatroomColumns);

const desktopMemberColumns = [
  { key: "order", dataKey: "order", title: "#", width: 60, align: "center" },
  { key: "smallHeadImgUrl", dataKey: "smallHeadImgUrl", title: "Avatar", width: 80, align: "center", cellRenderer: ({ cellData: url }: { cellData: string }) => (<ElAvatar shape="square" src={url}></ElAvatar>) },
  { key: "userName", dataKey: "userName", title: "Username", width: 220 },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 220, flexGrow: 1 },
];

const mobileMemberColumns = [
  { key: "smallHeadImgUrl", dataKey: "smallHeadImgUrl", title: "", width: 50, align: "center", cellRenderer: friendAvatarRenderer },
  { key: "nickName", dataKey: "nickName", title: "Nick Name", width: 100, flexGrow: 1 },
];

const memberColumns = computed(() => isMobile.value ? mobileMemberColumns : desktopMemberColumns);

const wcId = useRoute().params.wcId as string;
const router = useRouter();

// --- dialogs / state ---

const sendDialogVisible = ref(false);
const memberDialogVisible = ref(false);
const forwardDialogVisible = ref(false);
const jobDialogVisible = ref(false);
const sending = ref(false);

const sendDialogTitle = ref("Send");
const sendCtx = reactive({ receiver: "" });

type SendType = "text" | "voice" | "video" | "link" | "applet" | "app";
const sendType = ref<SendType>("text");

const form = reactive({
  text: { message: "", at: "" },
  voice: { contentUrl: "", lengthMs: 1000 },
  video: { videoPath: "", thumbPath: "" },
  link: { title: "", url: "", description: "", thumbUrl: "" },
  applet: { displayName: "", iconUrl: "", appId: "", pagePath: "", thumbUrl: "", title: "", userName: "" },
  app: { appXml: "" },
});

const forwardForm = reactive({ receiver: "", sourceNewMsgId: "", sourceMsgId: "" });

const lastJobIds = ref<string[]>([]);
const lastForwardResult = ref<SendJobsResult | null>(null);

const jobIdInput = ref("");
const jobRecord = ref<SendJobRecord | null>(null);
const jobRecordPretty = computed(() => (jobRecord.value ? JSON.stringify(jobRecord.value, null, 2) : ""));

const wechatUser = ref<Partial<WechatAccount>>({ headUrl: "", nickName: "", wAccount: "", username: "", mobilePhone: "", wcId: "", wId: "" });
const membersData = ref<WechatChatroomMember[]>([]);
const friendsData = ref<WechatContact[]>([]);
const chatroomsData = ref<WechatContact[]>([]);
const chatroomTitle = ref("");

const friendQuery = ref("");
const chatroomQuery = ref("");

const matches = (row: WechatContact, q: string) => {
  if (!q) return true;
  const needle = q.toLowerCase();
  return (
    (row.nickName ?? "").toLowerCase().includes(needle) ||
    (row.userName ?? "").toLowerCase().includes(needle)
  );
};

const filteredFriends = computed(() => friendsData.value.filter((r) => matches(r, friendQuery.value)));
const filteredChatrooms = computed(() => chatroomsData.value.filter((r) => matches(r, chatroomQuery.value)));

const friendPageNum = ref(1);
const friendPageSize = ref(20);
const chatroomPageNum = ref(1);
const chatroomPageSize = ref(20);

const paginatedFriends = computed(() => {
  const start = (friendPageNum.value - 1) * friendPageSize.value;
  return filteredFriends.value.slice(start, start + friendPageSize.value);
});

const paginatedChatrooms = computed(() => {
  const start = (chatroomPageNum.value - 1) * chatroomPageSize.value;
  return filteredChatrooms.value.slice(start, start + chatroomPageSize.value);
});

const paginationLayout = computed(() => (isMobile.value ? "prev, pager, next" : "prev, pager, next, jumper"));

watch(friendQuery, () => { friendPageNum.value = 1; });
watch(chatroomQuery, () => { chatroomPageNum.value = 1; });

const friendTableStyle = computed(() =>
  isMobile.value
    ? { height: 50 + Math.max(1, paginatedFriends.value.length) * 50 + "px" }
    : undefined
);
const chatroomTableStyle = computed(() =>
  isMobile.value
    ? { height: 50 + Math.max(1, paginatedChatrooms.value.length) * 50 + "px" }
    : undefined
);

const loadWechatUser = () => {
  getWechatUser(wcId).then(res => {
    if (res.successful) {
      const { friends, chatrooms, ...baseUser } = res.result;
      wechatUser.value = baseUser;

      // friends/chatrooms may be absent for offline or freshly-logged-in
      // accounts whose address book hasn't been fetched yet — default to [].
      const friendList = friends ?? [];
      const chatroomList = chatrooms ?? [];
      friendList.forEach((f, i) => { f.order = i + 1; });
      chatroomList.forEach((c, i) => { c.order = i + 1; });

      friendsData.value = friendList;
      chatroomsData.value = chatroomList;
    }
  });
}

const refreshFriends = () => {
  wechatRefreshFriendsInfo(wcId).then(res => {
    if (res.successful) {
      const r = res.result as { message?: string } | undefined;
      ElMessage({ message: r?.message ?? "已开始后台刷新", type: "info" });
    } else {
      ElMessage({ message: res.message ?? "刷新失败", type: "error" });
    }
  });
}

const openSendDialog = (nickName: string, receiver: string) => {
  sendDialogTitle.value = `Send to ${nickName}`;
  sendCtx.receiver = receiver;
  lastJobIds.value = [];
  sendDialogVisible.value = true;
};

const openForwardDialog = () => {
  lastJobIds.value = [];
  lastForwardResult.value = null;
  forwardDialogVisible.value = true;
};

const openJobStatusDialog = () => {
  jobRecord.value = null;
  jobDialogVisible.value = true;
};

const handleSendResult = (res: { successful: boolean; result?: SendJobsResult; message?: string }) => {
  if (res?.successful && res.result) {
    ElMessage.success(`已入队 ${res.result.jobIds?.length ?? 0} 个任务`);
    lastJobIds.value = res.result.jobIds ?? [];
    return res.result;
  }
  ElMessage.error(res?.message ?? "发送失败");
  return null;
};

const dispatchSend = async () => {
  sending.value = true;
  try {
    const receiver = sendCtx.receiver;
    let res;
    switch (sendType.value) {
      case "text":
        res = await wechatSendMessage(wcId, receiver, form.text.message, form.text.at);
        // /send_message returns either { receivers, jobIds } (new) or
        // [...receivers] (very old clients). Normalize.
        if (res?.successful && Array.isArray((res as any).result)) {
          (res as any).result = { receivers: (res as any).result, jobIds: [] };
        }
        break;
      case "voice":
        res = await wechatSendVoice(wcId, receiver, form.voice.contentUrl, form.voice.lengthMs);
        break;
      case "video":
        res = await wechatSendVideo(wcId, receiver, form.video.videoPath, form.video.thumbPath);
        break;
      case "link":
        res = await wechatSendLink(wcId, receiver, { ...form.link });
        break;
      case "applet":
        res = await wechatSendApplet(wcId, receiver, { ...form.applet });
        break;
      case "app":
        res = await wechatSendApp(wcId, receiver, form.app.appXml);
        break;
    }
    if (res) handleSendResult(res as any);
  } catch (e) {
    ElMessage.error((e as Error).message ?? "发送失败");
  } finally {
    sending.value = false;
  }
};

const dispatchForward = async () => {
  if (!forwardForm.receiver) {
    ElMessage.error("请填写接收者");
    return;
  }
  const source: { sourceNewMsgId?: number; sourceMsgId?: number } = {};
  if (forwardForm.sourceNewMsgId) source.sourceNewMsgId = Number(forwardForm.sourceNewMsgId);
  if (forwardForm.sourceMsgId) source.sourceMsgId = Number(forwardForm.sourceMsgId);
  if (source.sourceNewMsgId == null && source.sourceMsgId == null) {
    ElMessage.error("请填写 sourceNewMsgId 或 sourceMsgId");
    return;
  }
  sending.value = true;
  try {
    const res = await wechatForwardBySource(wcId, forwardForm.receiver, source);
    const result = handleSendResult(res as any);
    if (result) lastForwardResult.value = result;
  } catch (e) {
    ElMessage.error((e as Error).message ?? "转发失败");
  } finally {
    sending.value = false;
  }
};

const queryJob = (id: string) => {
  if (!id) return;
  jobIdInput.value = id;
  jobDialogVisible.value = true;
  wechatGetJob(id).then(res => {
    if (res?.successful) {
      jobRecord.value = res.result;
    } else {
      ElMessage.error(res?.message ?? "未找到任务");
      jobRecord.value = null;
    }
  }).catch((e) => {
    ElMessage.error((e as Error).message ?? "查询失败");
  });
};

const showMembers = (id: string) => {
  if (!wechatUser.value.wId) return;
  wechatGetChatroomMembers(wechatUser.value.wId, id).then(res => {
    if (res.successful) {
      res.result.forEach((item, idx) => { item.order = idx + 1; });
      membersData.value = res.result;
      memberDialogVisible.value = true;
    }
  });
}

loadWechatUser();
</script>

<style scoped>
.row {
  margin-bottom: 12px;
}

.row > .el-col {
  line-height: 30px;
}

.avatar-row > .el-col {
  line-height: normal;
}

.caption {
  text-align: right;
  color: #606266;
}

.inner-table,
.member-table {
  height: 400px;
  margin-top: 8px;
}

.list-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.list-search {
  max-width: 240px;
  flex: 1 1 160px;
}

.list-count {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}

.tools-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tools-hint {
  color: #909399;
  font-size: 12px;
}

.form-hint {
  color: #909399;
  font-size: 12px;
  margin-top: -8px;
}

.job-result {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
}

.job-result-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.job-result-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
}

.job-result-id {
  word-break: break-all;
  flex: 1 1 auto;
}

.forward-result {
  margin-top: 12px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
}

.page-header {
  margin-bottom: 16px;
}

.job-record {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  max-height: 360px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}

@media (max-width: 768px) {
  .caption {
    text-align: left;
    font-weight: 600;
    margin-top: 4px;
  }

  .row {
    margin-bottom: 8px;
  }

  /* On mobile the friend / chatroom tables size to their data via
     inline style on .inner-table, so don't impose a min-height that
     would force them taller than the visible rows. */
  .inner-table {
    height: auto;
    min-height: 0;
    margin-top: 8px;
  }

  .member-table {
    height: 50vh;
    min-height: 280px;
  }

  .list-toolbar {
    gap: 6px;
  }

  .list-toolbar .el-pagination {
    width: 100%;
    justify-content: center;
  }
}
</style>
